import axios from 'axios';
import { NextRouter } from 'next/router';
import qs from 'qs';

export function setInviteId(venue_id: string, invite_code: string) {
  localStorage.setItem(`invite:${venue_id}`, invite_code);
}

export function removeInviteId(venue_id: string) {
  localStorage.removeItem(`invite:${venue_id}`);
}

export function canClaimVenue(router: NextRouter) {
  if (router.query) {
    return false;
  }

  if ('invite_code' in router.query) {
    return true;
  }

  return false;
}

export async function claimVenue(venue_id: string) {
  const invite_code = localStorage.getItem(`invite:${venue_id}`);

  // if (!invite_code) {
  //   throw new Error(
  //     'No valid invitation found, please click the link in your email again.'
  //   );
  // }

  const response = await axios.post(`/api/venue/${venue_id}/claim`, {
    invite_code,
  });

  if (response.status !== 200) {
    throw new Error(
      'Something went wrong, please click the link in your email again.'
    );
  } else {
    return response;
  }
}
